import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/suppliers`)
  return data.data
}

export const useSuppliers = () => {
  const { data, ...props } = useQuery(
    queryKeys.SUPPLIERS,
    () => getData(),
  )
  return { data, ...props }
}
